/*
 * marking-labels/templates.js — четыре этикетки, которые продавец с кодами
 * «Честного ЗНАКа» на самом деле печатает.
 *
 *   cz       — только ЧЗ: DataMatrix + КИ текстом (+ название, артикул, если
 *              заполнена карточка товара). То, что печатает шаблон СУЗ, но в
 *              размере вашей ленты, а не 60×35.
 *   cz_wb    — ЧЗ + штрихкод Wildberries (EAN-13 или Code 128, без цены):
 *              одна наклейка вместо двух, 58×40 / 58×30 / 58×60.
 *   cz_ozon  — ЧЗ + штрихкод Ozon (OZN… Code 128 или ваш EAN), название ≤ 48,
 *              артикул ≤ 22, цвет ≤ 24, размер ≤ 18 знаков — пределы генератора
 *              этикеток Ozon.
 *   cz_tr017 — ЧЗ + товарный ярлык одежды по ТР ТС 017/2011 ст. 9: наименование,
 *              состав (%), размер, изготовитель и адрес, страна, дата
 *              изготовления, уход (текстом), знак EAC — только при отмеченном
 *              сертификате/декларации.
 *
 * Геометрия — в МИЛЛИМЕТРАХ от размера этикетки, НАСТОЯЩЕГО размера DataMatrix
 * (его решает модуль в точках принтера, label-maker/matrix.js) и ИЗМЕРЕННОЙ
 * ширины КИ (`fit` меряет её тем же измерителем, что и раскладка). На выходе —
 * элементы /label-maker (доли безопасного поля), дальше их раскладывает тот же
 * layout.js, рисуют те же render.js и pdf.js.
 *
 * ПЕРВЫЙ ЭКРАН — БЕЗ ЖЁЛТОГО. `fit` перебирает варианты КИ — «(01)…/(21)…»,
 * «01…/21…», без КИ — и отдаёт первый, где на пробах партии ничего не
 * вылезло и не ужалось ниже читаемого. Человек, сам включивший «КИ: да»,
 * получает именно это и честное предупреждение, если не влезло.
 *
 * Чистый модуль. Тесты — tests/js/marking-labels-templates.test.mjs.
 */
(function (root, factory) {
    'use strict';
    var api = factory();
    if (typeof module !== 'undefined' && module.exports) module.exports = api;
    if (root) root.MarkingTemplates = api;
})(typeof self !== 'undefined' ? self : (typeof window !== 'undefined' ? window : null), function () {
    'use strict';

    var SAFE = 1.5;            // = LabelLayout.SAFE_MM
    var QUIET = 2;             // тихая зона DataMatrix, мм (= LabelMatrix.QUIET_MM)
    var IDS = ['cz', 'cz_wb', 'cz_ozon', 'cz_tr017'];

    /* Кегли, мм. КИ и вспомогательные строки — НЕ ужимаются (minSize = size):
       ужатая ниже 2,6 мм строка — это предупреждение «мелко», а оно на первом
       экране не нужно; не влезло — `fit` возьмёт следующий вариант. */
    var KI = 2.3, LH = 1.18;
    var KI_BLOCK = KI * LH * 2 + 0.2;
    var NAME = 2.8, NAME_MIN = 2.6, META = 2.4, BODY = 2.4;
    var META2 = META * LH * 2 + 0.2;   // строка «артикул · размер · цвет» — до двух строк

    /* Пределы полей генератора этикеток Ozon (research 02, §4). */
    var OZON_LIMITS = { name: 48, article: 22, color: 24, size: 18 };
    /* Знак EAC (Решение КТС № 711): квадрат, не менее 5 мм. */
    var EAC_MIN_MM = 5;

    function inner(fmt) { return { W: fmt.w - 2 * SAFE, H: fmt.h - 2 * SAFE }; }
    function qeOf() { return Math.max(0, QUIET - SAFE); }   // тихая зона внутри поля у края этикетки

    /* Прямоугольник в мм безопасного поля → доли (формат элементов layout.js). */
    function rel(I, x, y, w, h) {
        return { x: x / I.W, y: y / I.H, w: Math.max(0, w) / I.W, h: Math.max(0, h) / I.H };
    }

    function text(I, name, tpl, x, y, w, h, o) {
        o = o || {};
        var r = rel(I, x, y, w, h);
        var size = o.size || META;
        return {
            type: 'text', name: name, text: tpl, x: r.x, y: r.y, w: r.w, h: r.h,
            size: size, minSize: o.minSize || size, align: o.align || 'left',
            valign: o.valign || 'top', font: 'noto', bold: !!o.bold,
            // ⚠️ layout.js читает maxLines: 0 как «одна строка» — без предела ключа нет вовсе.
            maxLines: o.maxLines ? o.maxLines : undefined,
            mode: o.mode || 'shrink', lineHeight: LH,
        };
    }

    /* DataMatrix: коробка = сам символ. Отступ от края этикетки — тихая зона
       минус поле безопасности (белое поле этикетки — тоже тихая зона). */
    function dm(I, x, y, side) {
        var r = rel(I, x, y, side, side);
        return { type: 'barcode', name: 'dm', symbology: 'gs1datamatrix', text: '{{code}}', x: r.x, y: r.y, w: r.w, h: r.h, align: 'center', valign: 'middle', quietMm: QUIET };
    }

    function linear(I, name, field, sym, x, y, w, h) {
        var r = rel(I, x, y, w, h);
        /* Символика — от ДАННЫХ записи (`symbologyField`): 13 цифр с верной
           контрольной — EAN-13, иначе Code 128 (`forRecord` подставляет). */
        return { type: 'barcode', name: name, symbology: sym, symbologyField: field + '_sym', text: '{{' + field + '}}', x: r.x, y: r.y, w: r.w, h: r.h, showText: true };
    }

    /* Знак EAC — по рисунку 3 Положения (Решение КТС № 711, ред. № 800):
       масштабная сетка 9 × 9 равных клеток, светлый фон.
         Е — столбец 1 целиком + клетки (2;1), (2;5), (2;9);
         А — столбцы 4 и 6 целиком + (5;1), (5;5);
         С — столбец 8 целиком + (9;1), (9;9);
       столбцы 3 и 7 — просветы. Толщина штриха = просвет = 1/9 стороны.
       Сверено с PDF решения на eec.eaeunion.org (PologenieEAC.pdf, с. 3). */
    var EAC_CELLS = [
        [0, 0, 1, 9], [1, 0, 1, 1], [1, 4, 1, 1], [1, 8, 1, 1],
        [3, 0, 1, 9], [5, 0, 1, 9], [4, 0, 1, 1], [4, 4, 1, 1],
        [7, 0, 1, 9], [8, 0, 1, 1], [8, 8, 1, 1],
    ];
    function eac(I, x, y, side) {
        var u = side / 9;
        return EAC_CELLS.map(function (c) {
            var r = rel(I, x + c[0] * u, y + c[1] * u, c[2] * u, c[3] * u);
            return { type: 'shape', name: 'eac', shape: 'rect', x: r.x, y: r.y, w: r.w, h: r.h, fill: '#000000' };
        });
    }

    var METAT = '{{meta}}';

    /* Строки КИ под выбранный вид: 'paren' — «(01)…», «(21)…»; 'bare' — «01…»,
       «21…» (на 4 знака короче); 'off' — нет. */
    function kiTexts(code, mode) {
        if (!code || mode === 'off') return ['', ''];
        var g = code.gtin || '', s = code.serial != null ? code.serial : '';
        return mode === 'bare' ? ['01' + g, '21' + s] : ['(01)' + g, '(21)' + s];
    }

    /* Собрать элементы шаблона.
     *   o.dmMm   — сторона DataMatrix в мм (модуль × модули)
     *   o.kiMode — 'paren' | 'bare' | 'off'
     *   o.kiW    — ширина самой длинной строки КИ этим видом, мм (её меряет `fit`)
     *   o.eac    — показывать EAC (только при сертификате/декларации)
     *   o.hasText — есть ли у товаров партии название/артикул
     * → { elements, warnings, inner } */
    function build(id, fmt, o) {
        o = o || {};
        var I = inner(fmt), qe = qeOf();
        var side = Math.max(5, +o.dmMm || 14);
        var els = [], warnings = [];
        var landscape = I.W >= I.H * 1.15;
        var mode = o.kiMode || 'paren';
        var kiOn = mode !== 'off';
        var kiH = kiOn ? KI_BLOCK : 0;
        var kiW = kiOn ? Math.max(0, +o.kiW || 21) : 0;
        var hasText = o.hasText !== false;

        if (side + 2 * qe > Math.min(I.W, I.H) + 1e-9) warnings.push('dm_too_big');

        function kiLines(x, y, w, align) {
            if (!kiOn) return;
            els.push(text(I, 'ki1', '{{ki1}}', x, y, w, kiH / 2, { size: KI, mode: 'fixed', maxLines: 1, align: align }));
            els.push(text(I, 'ki2', '{{ki2}}', x, y + kiH / 2, w, kiH / 2, { size: KI, mode: 'fixed', maxLines: 1, align: align }));
        }

        if (id === 'cz' || IDS.indexOf(id) < 0) {
            var colX = qe + side + QUIET, colW = I.W - colX;
            var sideBySide = landscape && colW >= Math.max(kiW + 0.4, hasText ? 14 : 0);
            if (sideBySide && !hasText) {
                // Только код и КИ: пара «код | КИ» по центру этикетки, КИ — по
                // середине высоты кода. Ни угла, ни пустого правого верха.
                var gw = side + (kiOn ? QUIET + kiW : 0);
                var gx = Math.max(qe, (I.W - gw) / 2);
                var gy = Math.max(qe, (I.H - side) / 2);
                els.push(dm(I, gx, gy, side));
                kiLines(gx + side + QUIET, gy + (side - kiH) / 2, Math.min(kiW + 0.4, I.W - gx - side - QUIET), 'left');
            } else if (sideBySide) {
                // Без КИ строке «артикул · размер · цвет» отдаётся третья строка —
                // место КИ: на узкой колонке длинный артикул иначе не встаёт.
                var mL = kiOn ? 2 : 3, mH = META * LH * mL + 0.2;
                els.push(dm(I, qe, Math.max(qe, (I.H - side) / 2), side));
                els.push(text(I, 'name', '{{name}}', colX, 0, colW, Math.max(3, I.H - kiH - mH - 0.4), { size: NAME, minSize: NAME_MIN, bold: true, maxLines: 4 }));
                els.push(text(I, 'meta', METAT, colX, I.H - kiH - mH - 0.2, colW, mH, { size: META, maxLines: mL, valign: 'bottom' }));
                kiLines(colX, I.H - kiH, colW, 'left');
            } else if (hasText && landscape && colW >= 12) {
                // Невысокая лента с крупным кодом: код слева сверху, название —
                // в колонке справа во всю высоту кода; под кодом во всю ширину —
                // строка «артикул · размер · цвет», под ней КИ.
                els.push(dm(I, qe, qe, side));
                els.push(text(I, 'name', '{{name}}', colX, 0, colW, side + qe, { size: NAME_MIN, minSize: NAME_MIN, bold: true, maxLines: 5 }));
                // Строка «артикул · размер · цвет» — во вторую строку, если под ней
                // ещё встаёт КИ (или КИ нет): длинный артикул не должен выталкивать
                // этикетку в предупреждение.
                var my = qe + side + QUIET - 0.6;
                var mh = my + META2 + kiH <= I.H + 1e-6 ? META2 : META * LH + 0.2;
                els.push(text(I, 'meta', METAT, 0, my, I.W, mh, { size: META, maxLines: mh === META2 ? 2 : 1 }));
                kiLines(0, my + mh, I.W, 'left');
                if (my + mh + kiH > I.H + 0.2) warnings.push('text_row_short');
            } else {
                // Код по центру, КИ под ним по центру; группа — по центру высоты
                // (на портретной ленте — сверху, под КИ встаёт название).
                var gh = side + (kiOn ? QUIET - 0.6 + kiH : 0);
                var ty = landscape || !hasText ? Math.max(qe, (I.H - gh) / 2) : qe;
                els.push(dm(I, (I.W - side) / 2, ty, side));
                var ky = ty + side + QUIET - 0.6;
                kiLines(0, ky, I.W, 'center');
                if (hasText && !landscape) {
                    var yn = ky + kiH + 0.6;
                    if (I.H - yn > 3.6) els.push(text(I, 'name', '{{name}}', 0, yn, I.W, I.H - yn - 3.2, { size: NAME, minSize: NAME_MIN, bold: true, align: 'center', maxLines: 4 }));
                    if (I.H - yn > 7) els.push(text(I, 'meta', METAT, 0, I.H - 3, I.W, 3, { size: META, align: 'center', maxLines: 1 }));
                }
                if (kiOn && ky + kiH > I.H + 0.2) warnings.push('text_row_short');
            }
        } else if (id === 'cz_wb' || id === 'cz_ozon') {
            var field = id === 'cz_wb' ? 'wb' : 'ozon';
            // Код ЧЗ — слева сверху, текст справа, штрихкод маркетплейса — полосой внизу.
            var stripH = Math.min(14, Math.max(8, I.H * 0.36));
            var topH = I.H - stripH - 0.5;
            if (side + qe + QUIET > topH + 0.6) warnings.push('dm_crowds_barcode');
            els.push(dm(I, qe, qe, side));
            var tx = qe + side + QUIET, tw = I.W - tx;
            if (tw < 14) warnings.push('text_column_narrow');
            if (hasText) {
                els.push(text(I, 'name', '{{name}}', tx, 0, tw, Math.max(3, topH - kiH - META2 - 0.4), { size: NAME_MIN, minSize: NAME_MIN, bold: true, maxLines: 3 }));
                els.push(text(I, 'meta', METAT, tx, topH - kiH - META2 - 0.2, tw, META2, { size: META, maxLines: 2, valign: 'bottom' }));
                kiLines(tx, topH - kiH, tw, 'left');
            } else {
                kiLines(tx, Math.max(0, qe + (side - kiH) / 2), tw, 'left');
            }
            var bw = Math.min(I.W, 46), by = Math.max(topH + 0.5, qe + side + QUIET - 0.5);
            els.push(linear(I, field, field, 'code128', (I.W - bw) / 2, by, bw, I.H - by));
        } else if (id === 'cz_tr017') {
            // Ярлык одежды: код справа сверху, слева — наименование и модель; ниже —
            // обязательные сведения ст. 9 ТР ТС 017 во всю ширину; EAC — внизу справа.
            var dx = I.W - qe - side;
            els.push(dm(I, dx, qe, side));
            var lw = dx - QUIET;
            if (lw < 14) warnings.push('text_column_narrow');
            els.push(text(I, 'name', '{{name}}', 0, 0, lw, Math.max(3, side * 0.62), { size: NAME, minSize: NAME_MIN, bold: true, maxLines: 3 }));
            els.push(text(I, 'meta', METAT, 0, side * 0.62 + 0.3, lw, Math.max(3, side * 0.38), { size: META, maxLines: 2 }));
            var y1 = qe + side + QUIET;
            var kiLine = kiOn ? KI * LH + 0.2 : 0;
            var eacSide = o.eac ? Math.max(EAC_MIN_MM, Math.min(8, I.W * 0.12)) : 0;
            var bodyH = I.H - y1 - kiLine;
            var bodyW = I.W - (eacSide ? eacSide + 1.2 : 0);
            if (bodyH < 8) warnings.push('tr017_too_small');
            els.push(text(I, 'body', '{{tr017}}', 0, y1, bodyW, Math.max(3, bodyH), { size: BODY }));
            if (eacSide) eac(I, I.W - eacSide, I.H - eacSide - kiLine, eacSide).forEach(function (e) { els.push(e); });
            if (kiOn) els.push(text(I, 'ki1', '{{ki1}}{{ki2}}', 0, I.H - kiLine, I.W, kiLine, { size: KI, mode: 'fixed', maxLines: 1 }));
        }

        return { elements: els, warnings: warnings, inner: I };
    }

    /* Запись для одной этикетки: код + карточка товара (по GTIN). */
    function resolveRecord(code, card, tr, kiMode) {
        card = card || {};
        tr = tr || {};
        var meta = [card.article, card.size ? (tr.size || '') + card.size : '', card.color].filter(Boolean).join(' · ');
        var wb = String(card.wb || '').replace(/\s+/g, '');
        var oz = String(card.ozon || '').replace(/\s+/g, '');
        var lines017 = [];
        if (card.composition) lines017.push((tr.composition || '') + card.composition);
        if (card.size) lines017.push((tr.size || '') + card.size);
        if (card.maker) lines017.push((tr.maker || '') + card.maker);
        if (card.country) lines017.push((tr.country || '') + card.country);
        if (card.date) lines017.push((tr.date || '') + card.date);
        if (card.care) lines017.push((tr.care || '') + card.care);
        var k = kiTexts(code, kiMode || 'paren');
        return {
            code: code.code,
            gtin: code.gtin,
            ki1: k[0], ki2: k[1],
            ki_short: code.ki || '',
            name: card.name || '',
            article: card.article || '', size: card.size || '', color: card.color || '',
            meta: meta,
            wb: wb, ozon: oz,
            wb_sym: linearSymbology(wb), ozon_sym: linearSymbology(oz),
            tr017: lines017.join('\n'),
        };
    }

    /* Элементы для конкретной записи: символика баркода маркетплейса — по данным. */
    function forRecord(els, rec) {
        return els.map(function (el) {
            if (!el.symbologyField) return el;
            var c = {};
            for (var k in el) if (Object.prototype.hasOwnProperty.call(el, k)) c[k] = el[k];
            c.symbology = rec[el.symbologyField] || 'code128';
            return c;
        });
    }

    /* EAN-13 — если это 13 цифр с верной контрольной (баркоды WB «20…»),
       иначе Code 128 (OZN…, свои артикулы). */
    function linearSymbology(v) {
        if (/^\d{13}$/.test(v)) {
            var sum = 0;
            for (var i = 0; i < 12; i++) sum += (+v[i]) * (i % 2 ? 3 : 1);
            if ((10 - sum % 10) % 10 === +v[12]) return 'ean13';
        }
        return 'code128';
    }

    /* ── подбор: первый вариант, где на пробах партии всё помещается ───────
     * probes: [{code (разобранный код), card}] — самый длинный серийный, по
     *         коду на каждый товар (с его карточкой).
     * deps:   { layoutLabel, measure, merge, tr, dpi, maxModuleMm }
     * o.dm:   [{dots, mm}] — допустимые размеры кода, от крупного к мелкому
     *         (или o.dmMm + o.dots — один размер, выбранный человеком)
     * o.ki:   'auto' (перебор) | 'on' (только «(01)…») | 'off'
     * Порядок: КИ «(01)…» → «01…» на каждом размере кода от крупного к мелкому,
     * и только потом без КИ — код помельче, но в пределах окна модуля, лучше
     * этикетки без КИ. «КИ: да» и «нет» перебирают только размеры кода.
     * → { elements, kiMode, kiW, dots, dmMm, issues: [{code, name}], warnings } */
    function fit(id, fmt, o, probes, deps) {
        o = o || {};
        probes = probes || [];
        var sizes = (o.dm && o.dm.length) ? o.dm : [{ dots: o.dots != null ? o.dots : null, mm: o.dmMm }];
        var modes = o.ki === 'off' ? ['off'] : (o.ki === 'on' ? ['paren'] : ['paren', 'bare']);
        var plan = [];
        modes.forEach(function (m) { sizes.forEach(function (sz) { plan.push([m, sz]); }); });
        if (o.ki !== 'off' && o.ki !== 'on') sizes.forEach(function (sz) { plan.push(['off', sz]); });
        var best = null;
        for (var pi = 0; pi < plan.length; pi++) {
            var r = tryOne(id, fmt, o, probes, deps, plan[pi][0], plan[pi][1]);
            if (!r.issues.length) return r;
            if (!best || r.issues.length < best.issues.length) best = r;
        }
        return best;
    }

    function tryOne(id, fmt, o, probes, deps, mode, sz) {
        var kiW = 0;
        if (mode !== 'off') {
            probes.forEach(function (p) {
                kiTexts(p.code, mode).forEach(function (t) {
                    kiW = Math.max(kiW, deps.measure(t, { size: KI, font: 'noto', bold: false }));
                });
            });
            if (!kiW) kiW = 21;
        }
        var b = build(id, fmt, { dmMm: sz.mm, kiMode: mode, kiW: kiW, eac: o.eac, hasText: o.hasText });
        var issues = b.warnings.map(function (w) { return { code: w, name: null }; });
        probes.forEach(function (p) {
            var rec = resolveRecord(p.code, p.card, deps.tr, mode);
            var lay = deps.layoutLabel({ w: fmt.w, h: fmt.h }, forRecord(b.elements, rec), {
                measure: deps.measure, dpi: deps.dpi, dots: sz.dots, maxModuleMm: deps.maxModuleMm,
                resolve: function (el) { return deps.merge(el.text, rec); },
            });
            lay.issues.forEach(function (x) {
                if (x.code === 'text_overflow' || x.code === 'text_tiny' || x.code === 'outside_label') {
                    issues.push({ code: x.code, name: x.name || null, size: x.size });
                }
            });
        });
        return { elements: b.elements, kiMode: mode, kiW: kiW, dots: sz.dots, dmMm: sz.mm, issues: issues, warnings: b.warnings };
    }

    /* Размеры кода, которые шаблон может дать на этой ленте: каждый целый
       модуль в окне, чей символ помещается в место шаблона, — от крупного.
       Не помещается ни один — самый мелкий допустимый с пометкой noFit. */
    function dmOptions(id, fmt, matrix, dpi, cols, rows, maxMm) {
        var box = dmBoxMax(id, fmt);
        var n = Math.max(cols, rows);
        var out = matrix.dotChoices(dpi, matrix.MIN_MODULE_MM, maxMm).map(function (c) {
            return { dots: c.dots, mm: n * c.moduleMm, moduleMm: c.moduleMm };
        }).filter(function (c) { return c.mm <= box + 1e-9; }).reverse();
        if (!out.length) {
            var g = matrix.pickDots({ dpi: dpi, cols: cols, rows: rows, boxW: box, boxH: box, quietMm: 0, maxMm: maxMm });
            out = [{ dots: g.dots, mm: g.wMm, moduleMm: g.moduleMm, noFit: true }];
        }
        return out;
    }

    /* Чего не хватает этикетке этого шаблона для этой карточки — до печати. */
    function audit(id, card) {
        card = card || {};
        var miss = [], over = [];
        if (id === 'cz_wb') {
            if (!card.wb) miss.push('wb');
            else if (String(card.wb).length > 30 || /\s/.test(card.wb)) over.push('wb');
        }
        if (id === 'cz_ozon') {
            if (!card.ozon) miss.push('ozon');
            for (var k in OZON_LIMITS) if (card[k] && String(card[k]).length > OZON_LIMITS[k]) over.push(k);
            if (!card.name) miss.push('name');
        }
        if (id === 'cz_tr017') {
            ['name', 'composition', 'size', 'maker', 'country'].forEach(function (f) { if (!card[f]) miss.push(f); });
        }
        return { missing: miss, tooLong: over };
    }

    /* Наибольшая сторона DataMatrix, которую шаблон отдаёт коду на этой
       этикетке (мм), — тихая зона и место под текст уже вычтены. По ней
       LabelMatrix.pickDots выбирает модуль: самый крупный, что помещается. */
    function dmBoxMax(id, fmt) {
        var I = inner(fmt), qe = qeOf();
        var landscape = I.W >= I.H * 1.15;
        if (id === 'cz_wb' || id === 'cz_ozon') {
            var stripH = Math.min(14, Math.max(8, I.H * 0.36));
            return Math.max(5, Math.min(I.H - stripH - qe - QUIET, I.W * 0.45));
        }
        if (id === 'cz_tr017') return Math.max(5, Math.min(I.W * 0.42, I.H * 0.45));
        if (landscape) {
            // Рядом с кодом — колонка под КИ (≈ 21 мм), либо КИ под кодом:
            // берётся вариант, где код крупнее.
            var side = Math.min(I.H - 2 * qe, I.W - qe - QUIET - 21);
            var stack = Math.min(I.W - 2 * qe, I.H - qe - QUIET - KI_BLOCK + 0.6);
            return Math.max(5, side, stack);
        }
        return Math.max(5, Math.min(I.W - 2 * qe, I.H * 0.55));
    }

    /* Ленты, на которых шаблон помещается без предупреждений (первая — по
       умолчанию); перебор держит tests/js/marking-labels-templates.test.mjs.
       ЧЗ + WB — только размеры, которые WB принимает (58×40, 58×30, 58×60);
       ярлык одежды — от 58×60: на 40×30 ст. 9 ТР ТС 017 не уместить. */
    var SIZES = {
        cz: ['roll-58x40', 'roll-58x30', 'roll-58x60', 'roll-43x25', 'roll-40x30', 'roll-75x120', 'roll-100x150'],
        cz_wb: ['roll-58x40', 'roll-58x30', 'roll-58x60'],
        cz_ozon: ['roll-58x40', 'roll-58x60', 'roll-75x120', 'roll-100x150'],
        cz_tr017: ['roll-58x60', 'roll-75x120', 'roll-100x150'],
    };

    return {
        IDS: IDS, SIZES: SIZES, OZON_LIMITS: OZON_LIMITS, EAC_MIN_MM: EAC_MIN_MM, EAC_CELLS: EAC_CELLS,
        QUIET: QUIET, SAFE: SAFE, KI: KI,
        build: build, fit: fit, dmOptions: dmOptions, resolveRecord: resolveRecord, forRecord: forRecord, kiTexts: kiTexts,
        audit: audit, linearSymbology: linearSymbology, eac: eac, dmBoxMax: dmBoxMax,
    };
});
